export default __webpack_public_path__ + "static/media/loadingBG.8fb80bf9.png";